import { useState, useEffect } from "react";
import { T, SECTIONS, Icon } from "../AdminPanel";
import { useApi } from "../AdminPanel";

export default function DashboardPage({ token, onExpired }) {
  const { get } = useApi(token, onExpired);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    Promise.all([
      get("/images/"),
      get("/users/"),
    ]).then(([images, users]) => {
      const bySection = {};
      for (const img of images) {
        bySection[img.section] = (bySection[img.section] || 0) + 1;
      }
      setStats({ total: images.length, users: users.length, bySection });
    }).catch(() => {});
  }, [get]);

  return (
    <div>
      <div className="adm-eyebrow">Обзор системы</div>
      <h1 style={{ fontFamily: "'Oswald', sans-serif", fontSize: 32, fontWeight: 400, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 28 }}>
        Панель управления
      </h1>

      {stats ? (
        <div className="adm-stats-grid">
          <div className="adm-stat">
            <div className="adm-stat__label">Всего изображений</div>
            <div className="adm-stat__value adm-stat__accent" style={{ color: T.accent }}>{stats.total}</div>
            <div className="adm-stat__sub">в базе данных</div>
          </div>
          <div className="adm-stat">
            <div className="adm-stat__label">Пользователи</div>
            <div className="adm-stat__value">{stats.users}</div>
            <div className="adm-stat__sub">зарегистрировано</div>
          </div>
          <div className="adm-stat">
            <div className="adm-stat__label">Галерея</div>
            <div className="adm-stat__value" style={{ color: "#b08d00" }}>{stats.bySection.gallery || 0}</div>
            <div className="adm-stat__sub">проектов</div>
          </div>
          <div className="adm-stat">
            <div className="adm-stat__label">Услуги</div>
            <div className="adm-stat__value">{stats.bySection.services || 0}</div>
            <div className="adm-stat__sub">изображений</div>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", gap: 12, marginBottom: 28 }}>
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="adm-stat" style={{ flex: 1, minHeight: 88, background: "rgba(18,49,51,0.04)" }} />
          ))}
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div className="adm-card">
          <div className="adm-eyebrow" style={{ marginBottom: 12 }}>Структура сайта</div>
          {SECTIONS.map(s => (
            <div key={s.value} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 0", borderBottom: `1px solid ${T.border}` }}>
              <span className="adm-section-chip" data-section={s.value}>{s.label}</span>
              <span style={{ fontFamily: "'Oswald', sans-serif", fontSize: 22, color: T.primary }}>
                {stats ? (stats.bySection[s.value] || 0) : "—"}
              </span>
            </div>
          ))}
        </div>
        <div className="adm-card">
          <div className="adm-eyebrow" style={{ marginBottom: 12 }}>Быстрые действия</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {[
              ["Загрузить изображение", "upload"],
              ["Управление галереей",   "images"],
              ["Список пользователей",  "users"],
            ].map(([label, p]) => (
              <a
                key={p}
                href="#"
                onClick={e => { e.preventDefault(); window._admNav?.(p); }}
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0", borderBottom: `1px solid ${T.border}`, textDecoration: "none", color: T.text }}
              >
                <span style={{ fontSize: 13 }}>{label}</span>
                {Icon.Arrow}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}